"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_ICON = void 0;
const SEARCH_ICON = exports.SEARCH_ICON = 'search-icon';